import { render, staticRenderFns } from "./NanTicker.vue?vue&type=template&id=43db9fe8"
import script from "./NanTicker.vue?vue&type=script&lang=js"
export * from "./NanTicker.vue?vue&type=script&lang=js"
import style0 from "./NanTicker.vue?vue&type=style&index=0&id=43db9fe8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports